import React from 'react'
import widgetsService from 'live/services/widgets'
import EditorService from 'live/services/editor'
import i18n from 'live/services/i18n'
import WidgetReducer from './widgetReducer'
import { reactWidgetWrapper } from 'live/widgets/decorators/react'
import { withSuspenseWrapper } from '../../SuspenseWrapper'

const WrapperEditor = withSuspenseWrapper(React.lazy(() => import('./static-data-editor')))
// import WrapperEditor from './static-data-editor'

// const WrapperStaticDataImpl = withSuspenseWrapper(React.lazy(() => import('./static-data'))) // com problema
import WrapperStaticDataImpl from './static-data'

export const REDUCER_LATEST = '@latest'

const widgetType = 'static-data'

const policies = {
    legends: false,
    restrictViewModeOptionsHeight: true,
    allowHideTooltip: false,
    handleOwnMissingData: false,
    allowXAxisConfig: false,
    allowYAxisConfig: false,
    defaultReducer: '@latest'
}

const DEFAULT_CHART_CONFIG = {
    spanFinal: false,
    chartConfig: {}
}

const EditorInfo = {
    label: 'Static Data for KPIs',
    order: 23,
    type: `${widgetType}-editor`,
    description: i18n('Static Data for Rigs and Wells Performance'),
    iconClass: 'far fa-tasks'
}

EditorService.newEditor({
    name: EditorInfo.type,
    editor: WrapperEditor,
    defaultWidgetType: widgetType
})

EditorService.newEditorMenuOption(widgetType, EditorInfo)

widgetsService.impl(widgetType, reactWidgetWrapper(WrapperStaticDataImpl, WidgetReducer))
widgetsService.queryHandlerKind(widgetType, widgetType)
widgetsService.config(widgetType, DEFAULT_CHART_CONFIG)
widgetsService.policies(widgetType, policies)
widgetsService.editor(widgetType, EditorInfo.type)
widgetsService.ui(widgetType, { editor: EditorInfo.type })
